module.exports = __webpack_public_path__ + "img/boostsend.5c8fb228.png";